// @ts-nocheck

import React, { useState } from "react";
import Link from "next/link";
import { useSelector } from "react-redux";
import { Row } from "antd";
import { noop } from "lodash";

import { selectAuthState } from "@/stores/slices/authSlice";
import { RADropdown, RAAvatar, Flex } from "@/components/customs";
import { PATH_ROUTES } from "@/config/routes";
import { RAFavicon } from "../RAFavicon";
import { ButtonV2 } from "@/components/customs/ButtonV2";
import { AircraftDropdown, ServiceDropdown } from "./_components";
import { SEAlertCircleFilled } from "@/components/svgs";
import { useHeaderSolid } from "@/hooks/HeaderSolidContext";
import s from "./HeaderDesktop.module.css";
import { getCookie } from "cookies-next";

export const HeaderDesktop = ({
	userMenuOptions,
	onClickOpenLogin = noop,
	onPressRequestQuote = noop,
	openFlightRequest,
}) => {
	const token = getCookie("ACCESS_TOKEN");
	const { user } = useSelector(selectAuthState);

	const { isSolid } = useHeaderSolid();

	const [openService, setOpenService] = useState(false);
	const [openAircraft, setOpenAircraft] = useState(false);

	return (
		<>
			<div className={s.container} data-solid-color={(isSolid || openService || openAircraft).toString()}>
				<div className={s.content}>
					<div className={s.navbar}>
						<div
							className={s.navbar_item}
							onClick={onPressRequestQuote}
							style={openFlightRequest ? { color: "#ffb11a" } : {}}
							data-testid="navbar_flightRequest"
						>
							Flight Request
						</div>
						<div
							data-aircraft-dropdown-trigger
							className={s.navbar_item}
							onClick={() => setOpenAircraft(!openAircraft)}
							style={openAircraft ? { color: "#ffb11a" } : {}}
						>
							Fleet
						</div>
						<div
							data-service-dropdown-trigger
							className={s.navbar_item}
							onClick={() => setOpenService(!openService)}
							style={openService ? { color: "#ffb11a" } : {}}
						>
							Services
						</div>
					</div>
					<div className={s.favicon}>
						<RAFavicon />
					</div>
					<div className={s.navbar}>
						<Link href={PATH_ROUTES.PATH_JOURNEY}>
							<div className={s.navbar_item}>Journey</div>
						</Link>
						<Link href={PATH_ROUTES.PATH_CONTACT_US}>
							<div className={s.navbar_item}>Contact</div>
						</Link>
						<Flex alignItems="center" justifyContent="center" style={{ width: 120 }}>
							{user?._id ? (
								<RADropdown
									items={userMenuOptions}
									element={
										<div data-testid="Header_userAvatarTrigger">
											<RAAvatar
												size={42}
												src={user.avatar?.url}
												name={`${user.first_name} ${user.last_name}`}
											/>
											{!user.activated && <SEAlertCircleFilled />}
										</div>
									}
								/>
							) : (
								<div className={s.btn_login}>
									<ButtonV2 data-testid="Header_loginBtn" onClick={onClickOpenLogin}>
										LOG IN
									</ButtonV2>
								</div>
							)}
						</Flex>
					</div>
				</div>
			</div>
			<ServiceDropdown open={openService} onUpdateOpenService={setOpenService} />
			<AircraftDropdown open={openAircraft} onUpdateOpenAircraft={setOpenAircraft} />
		</>
	);
};
